/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { ContextRouteAttachment, ContextRouteConfig } from '../router/context-router.interfaces';
import { ContextRouter, ContextRouterOutlet } from '../router/context-router.service';

/**
 * This component allows to define local (embedded/inline) scope for context routing.
 * It is convenient when page has many subtabs with routing-based navigation.
 */
@Component({
  standalone: false,
  selector: 'gh-context-router',
  template: '',
  providers: [ContextRouter],
  exportAs: 'ghContextRouter',
})
export class ContextRouterComponent implements OnInit, OnDestroy {
  /**
   * Set of available routes
   */
  @Input() routes: ContextRouteConfig[] = [];

  private _current: Maybe<string>;
  private initialized = false;
  private outlet: ContextRouterOutlet;

  constructor(private viewContainerRef: ViewContainerRef,
              private contextRouter: ContextRouter) {
  }

  /**
   * Sets name of current route
   */
  @Input()
  set current(name: Maybe<string>) {
    this._current = name;
    if (this.initialized) {
      this.updateCurrentRoute();
    }
  }

  get current(): Maybe<string> {
    return this._current;
  }

  ngOnInit(): void {
    this.initialized = true;

    this.routes.forEach((route) => {
      this.contextRouter.addRoute(route);
    });
    this.outlet = this.contextRouter.createOutlet(ContextRouteAttachment.Inline, this.viewContainerRef);

    this.updateCurrentRoute();
  }

  ngOnDestroy(): void {
    this.outlet.destroy();
  }

  private updateCurrentRoute(): void {
    this.outlet.navigate(this._current);
  }
}
